const dropDownStyles = {
    placeholder: styles => ({ ...styles, color: '#494089', padding: '0 8px 0 8px'}),
    control: styles => ({ ...styles, borderRadius: '20px'}),
    indicatorSeparator: styles => ({...styles, display: 'none'}),
    dropdownIndicator: styles => ({...styles, color: '#494089'})
}

export default dropDownStyles;